import { Executor } from '../executor'
import { createSvgElement, updateAttributesSvgElement } from '../svg'
import { Block } from './block'

export class OutputBlock extends Block {
  constructor(text, flowchart) {
    super(flowchart)

    this.text = text
  }

  create() {
    super.create()

    var rect = createSvgElement('polygon')
    updateAttributesSvgElement(rect, {
      class: 'flowchart-block',
      points: `20,0 ${this.width},0 ${this.width - 20},${this.height} 0,${this.height}`
    })

    var text = createSvgElement('text')
    updateAttributesSvgElement(text, {
      class: 'flowchart-text'
    })
    text.textContent = 'Display ' + this.text

    this.flowchart.element.appendChild(this.element)

    this.element.appendChild(rect)
    this.element.appendChild(text)

    var boundingClientRect = text.getBoundingClientRect()

    updateAttributesSvgElement(text, {
      x: 110 - boundingClientRect.width / 2,
      y: boundingClientRect.height / 4 + 35
    })
  }

  onExecute() {
    const data = this.flowchart.variables
    const text = this.text

    const out = new Executor()
      .addVariables(data)
      .execute(`return ${text};`)

    this.flowchart.listenOutput(out)

    return true
  }
}
